<template>
  <Header/>
  <router-view/>
  <Footer/>
</template>

<script>
import Header from '../src/components/Header'
import Footer from '../src/components/Footer'

export default {
  components:{
    Header,
    Footer
  }
}
</script>

<style>
h2{
  font-family: 'Montserrat', sans-serif;
}
#app {
  font-family: 'Montserrat', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
